import { loadStripe } from "@stripe/stripe-js";
import {
  addDoc,
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, functions } from "../lib/firebaseConfig";

export const useGetPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  const convertObjToArr = (obj) => {
    let arr = [];
    Object.keys(obj).forEach((key) => arr.push(obj[key]));
    return arr;
  };

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const docRef = collection(db, "products");
        const q = query(docRef, where("active", "==", true));
        const querySnapshot = await getDocs(q);
        const products = {};
        querySnapshot.forEach(async (productDoc) => {
          products[productDoc.id] = productDoc.data();

          const priceSnap = await getDocs(
            collection(db, "products", productDoc.id, "prices")
          );
          priceSnap.forEach(
            (priceDoc) =>
              (products[productDoc.id].prices = {
                priceId: priceDoc.id,
                ...priceDoc.data(),
              })
          );
        });
        setPlans(convertObjToArr(products));
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { loading, plans };
};

export const usePaySubscription = () => {
  const [authUser, authLoading, error] = useAuthState(auth);
  const [isLoaidingCheckoutPage, setLoadingCheckoutPage] = useState(false);

  const handlePay = async (plan) => {
    setLoadingCheckoutPage(true);
    let docRef;
    const { priceId } = plan.prices;
    try {
      const docSnap = await getDocs(
        collection(db, `customers/${authUser.uid}/subscriptions`)
      );
      // checking is user alredy brought any subscription or not
      // if yes will cut the plan trail for this particular user
      if (!docSnap.empty) {
        docRef = await addDoc(
          collection(db, `customers/${authUser.uid}/checkout_sessions`),
          {
            price: priceId,
            trial_from_plan: false,
            success_url: window.location.origin + "/ai-customisation-flow",
            cancel_url: window.location.origin,
          }
        );
      } else {
        docRef = await addDoc(
          collection(db, `customers/${authUser.uid}/checkout_sessions`),
          {
            price: priceId,
            success_url: window.location.origin + "/ai-customisation-flow",
            cancel_url: window.location.origin,
          }
        );
      }

      onSnapshot(docRef, async (snap) => {
        const { error, sessionId } = snap.data();
        if (error) {
          // Show an error to your customer and
          // inspect your Cloud Function logs in the Firebase console.
          alert(`An error occured: ${error.message}`);
        }
        if (sessionId) {
          const stripe = await loadStripe(
            "pk_test_51KtInGDVyYbwHg8XHhSAlWZZ9m7ia29PplKyijHiC4cy5SZ4swJdKxU9YgLiPMj3xMiANITWXgj1vJE9BlmRX8xc00A4Cn5VzE"
          );

          stripe.redirectToCheckout({ sessionId });
          // We have a Stripe Checkout URL, let's redirect.
          // window.location.assign(sessionId);
        }
      });
    } catch (error) {
      alert(`An error occured: ${error.message}`);
      setLoadingCheckoutPage(false);
    } finally {
      setLoadingCheckoutPage(false);
    }
  };

  return { isLoaidingCheckoutPage, handlePay };
};

export const useGetUserSubscription = () => {
  const [authUser, authLoading, error] = useAuthState(auth);
  const [subscription, setSubscripition] = useState(null);
  const [subscriptionLoading, setSubscripitionLoading] = useState(true);
  useEffect(() => {
    if (!authUser) return;
    const docRef = collection(db, `customers/${authUser.uid}/subscriptions`);
    const q = query(docRef, where("status", "in", ["trialing", "active"]));
    const unsubscribe = onSnapshot(q, (snap) => {
      setSubscripitionLoading(true);
      if (!snap.empty) {
        localStorage.setItem(
          "subscription",
          JSON.stringify(snap.docs[0].data())
        );
        // setSubscripition(snap.docs[0].data());
      }
      setSubscripitionLoading(false);
    });
    return () => {
      try {
        unsubscribe();
      } catch (error) {
        setSubscripitionLoading(false);
      } finally {
        setSubscripitionLoading(true);
      }
    };
  }, [authUser]);

  return { subscription, subscriptionLoading };
};

export const useCustomerPortal = () => {
  async function goToBillingPortal() {
    const functionRef = httpsCallable(
      functions,
      "ext-firestore-stripe-payments-createPortalLink"
    );

    const { data } = await functionRef({
      returnUrl: window.location.origin,
      locale: "auto",
    });
    console.log(data);
    window.location.assign(data.url);
  }

  return { goToBillingPortal };
};
